import React, { type PropsWithChildren } from 'react';

const Wrapper: React.FC<PropsWithChildren> = ({ children }) => <div className="wrapper">{children}</div>;

export default Wrapper;
